import { transparentInverseClasses } from '@liveauctioneers/hammer-ui-core/iconButton';
import { CornersOut } from '@liveauctioneers/hammer-ui-core/icons';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { WebRTCPlayer } from '@liveauctioneers/hammer-ui-core/webRTCPlayer';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    antMediaHostname: string;
    enlargeVideoLabel: string;
    fetchStreamId: () => Promise<string>;
    onEnlargeVideo: () => void;
    streamId: string;
    tooltipId: string;
};

/**
 * Live-stream PIP with an enlarge control. Uses a native `<button>` so the control stays reliably clickable
 * above the video surface; Hammer `IconButton` can end up under the video layer in this stacking context.
 */
export const BiddingConsoleGalleryVideoPip = ({
    antMediaHostname,
    enlargeVideoLabel,
    fetchStreamId,
    onEnlargeVideo,
    streamId,
    tooltipId,
}: Props) => (
    <div className="relative isolate overflow-hidden rounded-xs">
        <WebRTCPlayer
            allowFullscreen={false}
            allowPictureInPicture={false}
            showControls={false}
            className="relative z-0 aspect-video w-full rounded-xs"
            debug={false}
            fetchStreamId={fetchStreamId}
            hostname={antMediaHostname}
            streamId={streamId}
        />
        <Tooltip
            className="!z-[120]"
            id={tooltipId}
            place="bottom"
        >
            {enlargeVideoLabel}
        </Tooltip>
        <button
            aria-label={enlargeVideoLabel}
            className={cn(
                'hui-focus-visible-outline absolute right-0 top-0 z-[100] flex items-center justify-center rounded-full',
                'h-lg min-h-lg w-lg min-w-lg',
                transparentInverseClasses
            )}
            data-tooltip-id={tooltipId}
            onClick={onEnlargeVideo}
            type="button"
        >
            <CornersOut
                $withoutAriaLabel
                color="inherit"
                size="sm"
            />
        </button>
    </div>
);
